import { useStyleSheet } from '../../hooks/useStyleSheet';

export const useStyles = () =>
  useStyleSheet((theme) => ({
    root: {
      height: '100vh',
    },
    iconContainer: {
      height: '100%',
      padding: '1.25rem',
      borderRadius: '10px !important',
      backgroundColor: theme.palette.background.secondary,
    },
    iconPositionContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      borderRadius: 'inherit',
      boxShadow: theme.boxShadows.secondary.inset,
      height: '100%',
    },
  }));
